import type { ADFEntity } from '@atlaskit/adf-utils/types';
import { getTopLevelNodeTypes } from '@atlassian/conversation-assistant/utils/content-features';

import { isRemixRestrictedNodeType } from '../remix/remix-config';
import type { DynamicUiSource } from './types';

export const getUnsupportedRemixNodeTypes = (
	dynamicUiSource: DynamicUiSource | undefined,
	isNodeUnsupportedForRemix = (node: ADFEntity): boolean => isRemixRestrictedNodeType(node.type),
): string[] | undefined => {
	if (!dynamicUiSource) {
		return undefined;
	}

	const unsupportedNodeTypes = getTopLevelNodeTypes(
		dynamicUiSource.fullAdf,
		dynamicUiSource.startLocalId,
		dynamicUiSource.endLocalId,
		{
			includeNode: isNodeUnsupportedForRemix,
		},
	);

	return unsupportedNodeTypes.length > 0 ? unsupportedNodeTypes : undefined;
};
